import { Dispatch } from 'redux';
import { searchPolicyInfoService } from './PropertySearchDetails.services';
import {
  httpError,
  json,
  showWarnNotification,
  fetchPost,
  blob,
  showSuccessNotification,
} from 'common';
import {
  SetResultLoadingType,
  ResetResultsType,
  RESET_RESULTS,
  PROPERTY_SEARCH_DETAILS_ADD,
  PROPERTY_SEARCH_DETAILS_CLEAR,
  PROPERTY_SEARCH_DETAILS_LOADING,
  POLICY_INFO_SET_LOADING,
} from './PropertySearchDetails.types';
import { PropertyDetails, FullPropertyDetails } from '../models';
import { Property } from 'common/models';
import { printFile, saveFile } from 'common/helpers';

export function propertySearchDetailsAdd(item: any) {
  return {
    type: PROPERTY_SEARCH_DETAILS_ADD,
    payload: item,
  };
}

const setResultLoading = (loading: boolean): SetResultLoadingType => ({
  type: POLICY_INFO_SET_LOADING,
  loading,
});

export function propertySearchDetailsClear() {
  return {
    type: PROPERTY_SEARCH_DETAILS_CLEAR,
  };
}

export function propertySearchDetailsLoading(loading: boolean) {
  return {
    type: PROPERTY_SEARCH_DETAILS_LOADING,
    payload: loading,
  };
}

export function fetchPropertySearchDetailsAsync(
  searchId: number,
  parent: Property,
  bearerToken: string,
) {
  const apiUri: string = process.env.REACT_APP_API_URI as string;
  return (dispatch: Dispatch) => {
    dispatch(propertySearchDetailsLoading(true));
    fetchPost(`${apiUri}/properties/details/${searchId}`, parent, bearerToken)
      .then(httpError(dispatch))
      .then(json)
      .then((response) => {
        if (response.errorMessage) throw Error(response.errorMessage);
        return response;
      })
      .then((item: PropertyDetails) => {
        dispatch(propertySearchDetailsLoading(false));
        return dispatch(propertySearchDetailsAdd({ parent, details: item }));
      })
      .catch((error) => {
        dispatch(propertySearchDetailsLoading(false));
        showWarnNotification(`Fetch details`, error.message);
      });
  };
}

export function fetchHtmlPrintDetailsAsync(
  bearerToken: string,
  body: FullPropertyDetails,
  searchId: number,
  format: string,
) {
  const apiUri: string = process.env.REACT_APP_API_URI as string;
  return (dispatch: Dispatch) => {
    dispatch(propertySearchDetailsLoading(true));
    fetchPost(
      `${apiUri}/properties/details/${searchId}/export/${format}`,
      body,
      bearerToken,
    )
      .then(httpError(dispatch))
      .then(blob)
      .then((blob) => {
        dispatch(propertySearchDetailsLoading(false));
        printFile(blob);
      })
      .catch((error) => {
        dispatch(propertySearchDetailsLoading(false));
        showWarnNotification(`Fetch details file`, error.message);
      });
  };
}

export function exportPropertyDetailsAsync(
  body: any,
  searchId: any,
  format: string,
  action: 'print' | 'save',
  token: string,
) {
  const apiUri: string = process.env.REACT_APP_API_URI as string;
  return (dispatch: Dispatch) => {
    dispatch(propertySearchDetailsLoading(true));
    fetchPost(
      `${apiUri}/properties/details/${searchId}/export/${format}`,
      body,
      token,
    )
      .then(httpError(dispatch))
      .then(blob)
      .then((blob) => {
        dispatch(propertySearchDetailsLoading(false));
        if (action === 'print') {
          printFile(blob);
        }
        if (action === 'save') {
          saveFile(blob, `Report.${format}`);
          showSuccessNotification(`Fetch file`, `File was exported`);
        }
      })
      .catch((error) => {
        dispatch(propertySearchDetailsLoading(false));
        showWarnNotification(`Fetch details file`, error.message);
      });
  };
}

export const resetResults1 = (): ResetResultsType => ({
  type: RESET_RESULTS,
});

export const searchXosDocument =
  (company: string, docDesc: string, county: string, token: string) =>
  (dispatch: Dispatch) => {
    const body = { company, docDesc, county };
    dispatch(setResultLoading(true));
    //dispatch(resetResults1());
    searchPolicyInfoService(body, token)
      .then(httpError(dispatch))
      .then(json)
      .then((response: any) => {
        if (response.errorMessage) throw Error(response.errorMessage);
        showSuccessNotification(
          'Policy Information Online',
          'Your documents will be ready soon. Please check "Recent Reports".',
        );
        dispatch(setResultLoading(false));
      })
      .catch((error: any) => {
        dispatch(setResultLoading(false));
        showWarnNotification('Policy Information Online', error.message);
      });
  };
